"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncReportMetricToJSON = exports.AsyncReportMetricFromJSONTyped = exports.AsyncReportMetricFromJSON = exports.AsyncReportMetric = void 0;
/**
 *
 * @export
 */
exports.AsyncReportMetric = {
    AdCompletes: 'AD_COMPLETES',
    AvgStreamsPerListener: 'AVG_STREAMS_PER_LISTENER',
    AvgStreamsPerNewListener: 'AVG_STREAMS_PER_NEW_LISTENER',
    Clicks: 'CLICKS',
    CompletionRate: 'COMPLETION_RATE',
    Cpcl: 'CPCL',
    Cpm: 'CPM',
    Ctr: 'CTR',
    Frequency: 'FREQUENCY',
    FrequencyOfAdCompletes: 'FREQUENCY_OF_AD_COMPLETES',
    ImpressionsOffSpotify: 'IMPRESSIONS_OFF_SPOTIFY',
    ImpressionsOnSpotify: 'IMPRESSIONS_ON_SPOTIFY',
    IntentRate: 'INTENT_RATE',
    Listeners: 'LISTENERS',
    ListenerConversionRate: 'LISTENER_CONVERSION_RATE',
    NewListeners: 'NEW_LISTENERS',
    NewListenerConversionRate: 'NEW_LISTENER_CONVERSION_RATE',
    PlayedTo100: 'PLAYED_TO_100',
    PlayedTo25: 'PLAYED_TO_25',
    PlayedTo50: 'PLAYED_TO_50',
    PlayedTo75: 'PLAYED_TO_75',
    Reach: 'REACH',
    ReachOfAdCompletes: 'REACH_OF_AD_COMPLETES',
    Spend: 'SPEND',
    Starts: 'STARTS',
    Streams: 'STREAMS',
    Unmutes: 'UNMUTES',
    ModeledAddToCart: 'MODELED_ADD_TO_CART',
    ModeledLeads: 'MODELED_LEADS',
    ModeledPageViews: 'MODELED_PAGE_VIEWS',
    ModeledPurchases: 'MODELED_PURCHASES',
    UnmodeledAddToCart: 'UNMODELED_ADD_TO_CART',
    UnmodeledLeads: 'UNMODELED_LEADS',
    UnmodeledPageViews: 'UNMODELED_PAGE_VIEWS',
    UnmodeledPurchases: 'UNMODELED_PURCHASES',
    VideoViews: 'VIDEO_VIEWS',
    VideoExpands: 'VIDEO_EXPANDS',
    VideoExpandRate: 'VIDEO_EXPAND_RATE',
    SkadAppInstalls: 'SKAD_APP_INSTALLS',
    KochavaAppInstalls: 'KOCHAVA_APP_INSTALLS',
    AppsflyerAppInstalls: 'APPSFLYER_APP_INSTALLS',
    PageViews: 'PAGE_VIEWS',
    Leads: 'LEADS',
    AddToCart: 'ADD_TO_CART',
    Purchases: 'PURCHASES',
    Revenue: 'REVENUE',
    AverageOrderValue: 'AVERAGE_ORDER_VALUE',
    ReturnOnAdSpend: 'RETURN_ON_AD_SPEND',
    CustomerAcquisitionCost: 'CUSTOMER_ACQUISITION_COST',
    CostPerLead: 'COST_PER_LEAD',
    StartCheckout: 'START_CHECKOUT',
    Products: 'PRODUCTS',
    SignUps: 'SIGN_UPS',
    CustomEvent1: 'CUSTOM_EVENT_1',
    CustomEvent2: 'CUSTOM_EVENT_2',
    CustomEvent3: 'CUSTOM_EVENT_3',
    CustomEvent4: 'CUSTOM_EVENT_4',
    CustomEvent5: 'CUSTOM_EVENT_5',
    ECpc: 'E_CPC',
    StreamedImpressions: 'STREAMED_IMPRESSIONS'
};
function AsyncReportMetricFromJSON(json) {
    return AsyncReportMetricFromJSONTyped(json, false);
}
exports.AsyncReportMetricFromJSON = AsyncReportMetricFromJSON;
function AsyncReportMetricFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AsyncReportMetricFromJSONTyped = AsyncReportMetricFromJSONTyped;
function AsyncReportMetricToJSON(value) {
    return value;
}
exports.AsyncReportMetricToJSON = AsyncReportMetricToJSON;
